export default {
    'Close menu': 'Закрыть меню',
    'Close submenu': 'Закрыть подменю',
    'Open submenu': 'Открыть подменю',
    'Toggle submenu': 'Переключить подменю'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/screenreader/translations/ru.js
// module id = 105
// module chunks = 0